module.exports = __webpack_public_path__ + "static/media/no-image.873b3db0.jpg";